module.exports = __webpack_public_path__ + "img/dhea.fe36dd9b.png";